import app from 'flarum/forum/app';

import {extend} from 'flarum/extend';
import extractText from 'flarum/utils/extractText';

import EditUserModal from 'flarum/components/EditUserModal';
import RajceLinkButton from '../common/components/RajceLinkButton';
import SettingsPage from 'flarum/components/SettingsPage';
import Separator from 'flarum/components/Separator';
import SessionDropdown from 'flarum/components/SessionDropdown';
import UserPage from 'flarum/components/UserPage';

export default function () {
  extend(SettingsPage.prototype, 'accountItems', function (items) {
    items.remove('changeEmail');

    return items;
  });

  extend(EditUserModal.prototype, 'fields', function (items) {
    items.replace('username', <div className="Form-group">
        <label>{app.translator.trans('core.forum.edit_user.username_heading')}</label>
        <input
          className="FormControl"
          placeholder={extractText(app.translator.trans('core.forum.edit_user.username_label'))}
          bidi={this.username}
          disabled={true}
        />
      </div>
    );

    return items;
  });

  extend(SessionDropdown.prototype, 'items', function (items) {
    items.remove('settings');

    return items;
  });

  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    items.add('separator', Separator.component(), -90);
    items.add(
      'rajceUserLink',
      <RajceLinkButton active="1"
                       href={'https://' + user.attribute('username') + '.rajce.idnes.cz/'}
                       icon="far fa-address-card">
        {app.translator.trans('rajce_update.forum.user_page.user_link_button')}
      </RajceLinkButton>,
      -100
    );

    return items;
  });
}
